<script>
import api from "@/axios";
import Loader from "../components/loader.vue";
import Layout from '../../layouts/main.vue';
import PageHeader from '@/components/page-header.vue';
import appConfig from "@/app.config.json";
import { Vue3Lottie } from 'vue3-lottie';
import 'vue3-lottie/dist/style.css';
import {ref} from "vue";
import useVuelidate from "@vuelidate/core";
import Swal from "sweetalert2";
import { exportDataGrid } from 'devextreme/excel_exporter';
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import DxButton from "devextreme-vue/button";
import DxToolbar, {DxItem} from "devextreme-vue/toolbar";
import CustomStore from "devextreme/data/custom_store";
import {Workbook} from "exceljs";
import {saveAs} from "file-saver-es";
import moment from "moment/moment";
import AstronautJSON from "@/assets/animations/condp_anim.json";
import {helpers, required} from "@vuelidate/validators";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Movimentos de Ajuste de Estoque",
    meta: [{ name: "description", content: appConfig.description }]
  },

  components: { Layout, PageHeader, Loader, Vue3Lottie,
    DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations},

  data() {
    return {
      AstronautJSON,
      title: 'Cadastro Cfop',
      items: [
        {
          text: 'Fiscal',
          href: '/',
        },
        {
          text: 'Cfop',
          active: true,
        },
      ],
      loadingList: true,
      dataList: null,
      idData: null,
      totalList: 0,
      updating: false,
      regSelecionado:{},
      showModalEditar: false,
      submitted: false,
    }
  },

  validations: {
    regSelecionado :{
      descricao: {
        required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
      },
      codigo: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
    }
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted cfop-list_0')
    this.atualizaDataList()
  },

  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return { dropzoneFile, drop, v$: useVuelidate()};
  },

  methods: {

    /*atualizaPagina(){
      window.locale.reload()
    },*/

    criarNovoCfop() {
      console.log('criarNova')
      //this.$refs.childTable.setCriarNova(true)
      this.regSelecionado.id = null;
      this.regSelecionado.descricao = null;
      this.regSelecionado.codigo = null;

      this.showModalEditar = true
    },

    carregouGrid(e){
      console.log('carregouGrid')
      this.title = '(' + e.component.totalCount() + ') Cadastro de Cfop'

    },

    atualizaDataList(){
      console.log('atualizaDataList_CFOP')
      this.loadingList = true
      this.dataList = new CustomStore({
        key: "id",

        load: function(loadOptions){
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
          }
          return api.get(`${getBaseUrl()}api/indexcfops`, {
            params: paramsReq
          }).then(res => {
            console.log('then axios')
            console.log(res)
            return {
              data: res.data[0],
              totalCount: res.data[1]
            }
          }).catch((e) => {
            console.log('error cfops List')
            console.log(e)
          })
        },
      })

      this.loadingList = false
    },

    formSubmit(){
      console.log('formSubmit')
      this.submitted = true
      if (this.regSelecionado || this.regSelecionado.descricao) {
        this.showModalEditar = false
        this.loadingList = true
        this.errosValid = []

        api.post(`${getBaseUrl()}api/postcfop`, {
          cfopsdata: this.regSelecionado
        }).then((res) => {
          console.log('then axios post cfop')
          console.log(res.data)

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          this.atualizaDataList()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.loadingList = false
        })
      }
    },

    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          api.delete(`${getBaseUrl()}api/deletecfop`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            // console.log('then axios delete')
            // console.log(res.data)

            if(res.data === 'exclusao_realizada_com_sucesso') {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Informações excluídas com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })

              this.showModalEditar = false
              this.atualizaDataList()

            } else {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: "O endereço não pode ser excluído, pois existem produtos vinculados a ele!",
                showConfirmButton: false,
                timer: 1800
              })
            }
          })
        }
      })
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      this.regSelecionado = row.data

      if (this.regSelecionado) {
        console.log('regSelecionado: ', this.regSelecionado)
        this.showModalEditar = true
      }
    },

    /*onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          // console.log('onCellPrepared')
          // console.log(e.data.status)
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'FA':
              corStatus = 'rgb(77,179,53)'
              break
            case 'EL':
              corStatus = 'rgb(239,179,75)'
              break
            case 'CA':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'CO':
              corStatus = 'rgb(5,120,236)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },*/

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },
  },

}
</script>

<template>
  <Layout>

    <span class="float-end" style="z-index: 1000; position: absolute; top: 18px; right: 230px;">
      <Vue3Lottie :animationData="AstronautJSON" :height="250" :width="250" />
    </span>

    <PageHeader :title="title" :items="items" />

    <div class="mt-2">

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">

          <DxButton
              icon="plus"
              hint="Criar Novo Cfop"
              text="Novo Cfop"
              :on-click="criarNovoCfop"/>
        </DxItem>

      </DxToolbar>
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2" v-if="!updating">

      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">
        <!--          @cell-prepared="onCellPrepared"-->

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strProdutosList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            data-field="id"
            sort-order="desc"
            caption="ID"
            data-type="number"
            alignment="center"
            :filter-operations="['contains','=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

<!--        <DxColumn
            data-field="empresa"
            caption="Empresa"
            data-type="text"
            alignment="center"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>-->

        <DxColumn
            data-field="codigo"
            caption="Código"
            data-type="text"
            alignment="center"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="descricao"
            caption="Descrição"
            data-type="text"
            alignment="center"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>


        <DxColumn
            data-field="created_at"
            caption="Data"
            alignment="center"
            data-type="datetime"
            :format="formatDateTime"
            :filter-operations="['contains', '=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

      </DxDataGrid>
    </div>

    <b-modal :title="regSelecionado.id != null ? `Editar Cfop (${ regSelecionado.id })` : 'Criar Novo Cfop'" v-model="showModalEditar" hide-footer>
      <form>
        <div class="row">

          <div class="col-12">
            <div class="mb-3">
              <label for="descricao">Descrição</label>
              <input
                  id="descricao"
                  v-model="regSelecionado.descricao"
                  type="text"
                  class="form-control"
                  placeholder="Inserir descrição"
                  :class="{'is-invalid': submitted && v$.regSelecionado.descricao.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.descricao.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.descricao.required.$message">
                  {{ v$.regSelecionado.descricao.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="codigo">Código</label>
              <input
                  id="codigo"
                  v-model="regSelecionado.codigo"
                  type="text"
                  class="form-control"
                  placeholder="Inserir código"
                  :class="{'is-invalid': submitted && v$.regSelecionado.codigo.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.codigo.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.codigo.required.$message">
                  {{ v$.regSelecionado.codigo.required.$message }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="text-end mt-3">
          <b-button v-if="regSelecionado.id !== null" variant="danger" @click="deletar(regSelecionado.id)">
            <i class="mdi mdi-trash-can font-size-12 align-middle me-2"></i>
            Deletar
          </b-button>
          <b-button variant="success" class="ms-3" @click="formSubmit">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </form>
    </b-modal>

  </Layout>
</template>
